export default "__VITE_ASSET__CCuRa6Hj__"